import { Icon } from 'components/atoms/Icon'
import { cn } from 'lib/utils'
import type { ModalProps } from './types'
import { useModalAnimation } from './hooks'
import {
  Button,
  EButtonStyleVariant,
  EButtonVariant,
} from 'components/atoms/Button'

import './index.scss'

const mainClass = 'modal'

export const Modal = ({
  children,
  onClose,
  className = '',
  title,
}: ModalProps) => {
  const { modalRef, isVisible } = useModalAnimation()

  const modalClasses = cn(
    mainClass,
    `${mainClass}--fade`,
    isVisible && `${mainClass}--show`,
    className
  )

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) onClose()
  }

  return (
    <div ref={modalRef} className={modalClasses} tabIndex={-1} role="dialog">
      <div className={`${mainClass}-backdrop`} onClick={handleBackdropClick} />
      <div className={`${mainClass}__dialog`} role="document">
        <div className={`${mainClass}__content`}>
          {title && <div className={`${mainClass}__header`}>{title}</div>}
          <div className={`${mainClass}__body`}>{children}</div>
          <Button
            variant={EButtonVariant.BUTTON}
            buttonVariant={EButtonStyleVariant.SPECIAL}
            className={`${mainClass}__close`}
            onClick={onClose}
          >
            <Icon name="close" />
          </Button>
        </div>
      </div>
    </div>
  )
}
